<script setup>
import { defineProps } from 'vue';
import Icon from '../components/IconComponent.vue';

defineProps({
    navigate: {
        type: Function,
        required: true
    }
});

/*
const contactForm = reactive({
    name: '',
    email: '',
    subject: '',
    message: ''
});
const contactMessage = ref('');

const submitContact = () => {
    console.log('Contact form submitted:', contactForm);
    contactMessage.value = 'Your message has been sent successfully!';
    
    // Reset form
    contactForm.name = '';
    contactForm.email = '';
    contactForm.subject = '';
    contactForm.message = '';
};
*/
</script>

<template>
    <main class="container mx-auto px-4 py-16">
        <div class="text-center mb-12" v-reveal:up>
            <h1 class="text-4xl md:text-5xl font-extrabold text-gray-800 mb-3">Get in Touch</h1>
            <p class="text-gray-600 max-w-2xl mx-auto">We’d love to hear from you. Use the contact details below to get in touch with our team. We’re here to help you on your journey to abroad.</p>
        </div>
        
        <div class="max-w-xl mx-auto">
            <!-- Left Column: Send us a Message Form (Commented out) -->
            <!-- 
            ...
            -->

            <!-- Right Column: Contact Information -->
            <div class="space-y-8">
                <div class="p-6 md:p-8 rounded-xl border border-gray-100 shadow-lg bg-white" v-reveal:up>
                    <h2 class="text-2xl font-bold text-gray-800 mb-6">Contact Information</h2>
                    <ul class="space-y-4 text-gray-600">
                        <li class="flex items-start space-x-3">
                            <Icon name="call" class-name="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                            <span>+234 708-090-0495</span>
                        </li>
                        <li class="flex items-start space-x-3">
                            <Icon name="call" class-name="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                            <span>+1 (416) 555-0142</span>
                        </li>
                        <li class="flex items-start space-x-3">
                            <Icon name="whatsapp" class-name="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                            <a href="https://wa.me/2347080900495?text=Hello%20Swif%20Study%20Abroad%2C%20I%27d%20like%20to%20make%20an%20enquiry."
                                target="_blank" rel="noopener" aria-label="Chat with us on WhatsApp"
                                class="hover:text-primary hover:underline">+234 708-090-0495</a>
                        </li>
                        <li class="flex items-start space-x-3">
                            <ion-icon name="mail-outline" class="w-6 h-6 text-primary mt-1 flex-shrink-0"></ion-icon>
                            <span>swifstudyabroad@gmail.com</span>
                        </li>
                        <li class="flex items-start space-x-3">
                            <Icon name="time" class-name="w-6 h-6 text-primary mt-1 flex-shrink-0" />
                            <span>Monday - Friday: 9:00 AM - 5:00 PM</span>
                        </li>
                    </ul>
                </div>
                
                <!-- <div class="p-6 md:p-8 rounded-xl border border-gray-100 shadow-lg">
                    <h2 class="text-2xl font-bold text-gray-800 mb-6">Our Office</h2>
                    <p class="text-gray-600 mb-6">123 University Ave, Suite 400, Toronto, ON, Canada</p>
                    
                   
                    <div class="h-48 bg-gray-200 rounded-lg flex items-center justify-center text-gray-500 mb-6">
                        Map Placeholder
                    </div>
                    
                    <a href="https://maps.google.com/?q=123+University+Ave,+Toronto" target="_blank" class="flex items-center justify-center bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-blue-700 transition duration-300">
                        <Icon name="globe" class-name="w-5 h-5 mr-2" />
                        Get Directions
                    </a>
                </div> -->
            </div>
        </div>
    </main>
</template>
